import { useEffect, useState } from "react";
import { copyVisitsAPI, getAllVisits, getVisits } from "../../../api/protocol";
import { HandleApiError } from "../../../components/Notifications/APIErrorHandler";

export const useAllVisits = (protocolId) => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [totalSize, setTotalSize] = useState(0);
    const [query, setQuery] = useState({
        pagination: {
            page: 1,
            sizePerPage: 500,
            totalSize: 0
        },
        sort: {
            sortField: "Created",
            sortOrder: "desc"
        },
        filters: [{ stage: 0 }]
    });

    useEffect(() => {
        let isSubscribed = true;

        const fetchData = async () => {
            setIsLoading(true);
            setReload(false);
            try {
                const response = await getAllVisits(protocolId, query);
                if (isSubscribed) {
                    const paginatedResult = response.data;

                    setTotalSize(paginatedResult.count);
                    setData(paginatedResult.data);
                    setIsLoading(false);
                }
            }
            catch (error) {
                console.log(error);
                if (isSubscribed) {
                    HandleApiError(error);
                    setIsLoading(false);
                }
            }
        }

        fetchData();

        return () => isSubscribed = false;
    }, [protocolId, query, reload]);

    const handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {

        var newQuery = null;
        if (type === 'pagination') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.pagination.page = page;
            newQuery.pagination.sizePerPage = sizePerPage;

            setQuery(newQuery);
        }

        if (type === 'sort') {
            newQuery = JSON.parse(JSON.stringify(query));

            newQuery.sort.sortField = sortField;
            newQuery.sort.sortOrder = sortOrder;

            setQuery(newQuery);
        }
    }

    const handleFilterChange = (filterName, selectedValue) => {
        if (filterName) {
            var newQuery = JSON.parse(JSON.stringify(query));

            newQuery.filters[filterName] = selectedValue != null ? selectedValue.id : selectedValue;

            setQuery(newQuery);
        }
    }

    return [setData, data, query, totalSize, isLoading, handleTableChange, handleFilterChange, setReload];
}

export const useVisits = () => {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const fetchData = async (protocolId) => {
        setIsLoading(true);
        try {
            const response = await getVisits(protocolId);
            setData(response.data);
            setIsLoading(false);
        }
        catch (error) {
            console.log(error);
            HandleApiError(error);
            setIsLoading(false);
        }
    }
    return [fetchData, data, setData, isLoading];
}

export const useCopyVisits = () => {
    const [isLoading, setIsLoading] = useState(false);

    const copyVisits = async (protocolId, fromProtocolId, selectedVisitIds) => {
        try {
            setIsLoading(true);
            const response = await copyVisitsAPI(protocolId, fromProtocolId, selectedVisitIds);
            setIsLoading(false);

            return response;

        } catch (error) {
            HandleApiError(error);
            setIsLoading(false);

            return null;
        }
    }

    return [copyVisits, isLoading];
}